import React, { useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
// import PopupImage from "../assets/images/popup.png";
function PopupModal({
  imgSrc,
  link,
  className,
  onClose,
  maskClosable,
  closable,
  visible,
  isMobile,
  cookieKey = "VisitCookie",
}) {
  const onMaskClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose(e);
    }
  };

  // FIXME 방문 쿠키 강제 삭제, 점검을 위함, 오늘 하루 닫기도 비활성화
  // localStorage.removeItem("VisitCookie");

  // 이전방문 날짜
  const VISITED_BEFORE_DATE = localStorage.getItem(cookieKey);
  // 현재 날짜
  const VISITED_NOW_DATE = Math.floor(new Date().getDate());

  // console.log(VISITED_BEFORE_DATE)
  // console.log(VISITED_NOW_DATE)
  // localStorage.removeItem('VisitCookie')

  useEffect(() => {
    // 2025년 1월 1일 이후에는 팝업 미노출
    // const now = new Date();
    // const endDate = new Date("2026-12-31T23:59:59");

    // if (now > endDate) {
    //   onClose(true); // 팝업 닫기
    //   return;
    // }

    if (VISITED_BEFORE_DATE !== null) {
      const visitedDate = Number(VISITED_BEFORE_DATE);
      // 유효하지 않은 숫자인 경우 쿠키 삭제하고 팝업 표시
      if (isNaN(visitedDate)) {
        localStorage.removeItem(cookieKey);
        onClose(false);
        return;
      }

      if (visitedDate === VISITED_NOW_DATE) {
        onClose(true);
      }
      if (visitedDate !== VISITED_NOW_DATE) {
        // 날짜가 다르면 쿠키 삭제하고 팝업 표시 (새로운 날이므로)
        localStorage.removeItem(cookieKey);
        onClose(false);
      }
    }
  }, [VISITED_BEFORE_DATE]);

  const Dayclose = (e) => {
    if (onClose) {
      const expiry = new Date();
      const expiryDate = expiry.getDate();
      localStorage.setItem(cookieKey, expiryDate);
      onClose(true); // "오늘 하루 닫기"이므로 true 전달
    }
  };

  const close = (e) => {
    if (onClose) {
      onClose(); // 매개변수 없이 호출 (일반 닫기)
    }
  };

  return (
    <div elementId="modal-root">
      <ModalOverlay visible={visible} />
      <ModalWrapper
        className={className}
        onClick={maskClosable ? onMaskClick : null}
        tabIndex="-1"
        visible={visible}
      >
        <ModalInner tabIndex="0" className="modal-inner" isMobile={isMobile}>
          <ModalInner2>
            <ImgStyle>
              <a href={link} target="_blank" rel="noreferrer">
                <img
                  src={imgSrc}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "15px 15px 0px 0px",
                  }}
                  alt=""
                />
              </a>
            </ImgStyle>
            {closable && (
              <CloseStyle>
                <Close className="modal-close" onClick={Dayclose}>
                  오늘 하루 닫기
                </Close>
                <span className="modal-close"></span>
                <Close className="modal-close" onClick={close}>
                  닫기
                </Close>
              </CloseStyle>
            )}
          </ModalInner2>
        </ModalInner>
      </ModalWrapper>
    </div>
  );
}

PopupModal.propTypes = {
  visible: PropTypes.bool,
};

const ModalInner2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImgStyle = styled.div`
  margin-bottom: -3px;
`;

const CloseStyle = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  width: 100%;
  padding: 15px 0px;
  border-radius: 0 0 15px 15px;
  color: #000;
`;

const Close = styled.span`
  cursor: pointer;
  padding: 4px 10px;
`;

const ModalWrapper = styled.div`
  box-sizing: border-box;

  display: ${(props) => (props.visible ? "block" : "none")};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: auto;
  outline: 0;
`;

const ModalOverlay = styled.div`
  box-sizing: border-box;
  display: ${(props) => (props.visible ? "block" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
`;

const ModalInner = styled.div`
  box-sizing: border-box;
  position: relative;
  // box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
  // background-color: #fff;
  // border-radius: 10px;
  width: ${(props) => (props.isMobile ? "360px" : "480px")};
  max-width: 480px;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  padding: 40px 20px;
`;

export default React.memo(PopupModal);
